import angular from 'angular';

export const getTaskRelationFieldTypeLabel = (type, translateListFilter, fallback) => {
  switch (type) {
    //ResponsibleUser
    case 9:
      return translateListFilter(1, 'employeeprofile', fallback);
    //AssistantUser
    case 10:
      return translateListFilter(2, 'employeeprofile', fallback);
    //AssociateUser
    case 11:
      return translateListFilter(4, 'employeeprofile', fallback);
    //AssistantBackupUser
    case 12:
      return translateListFilter(3, 'employeeprofile', fallback);
    //BillingUser
    case 26:
      return translateListFilter(5, 'employeeprofile', fallback);
    //SeniorUser
    case 27:
      return translateListFilter(6, 'employeeprofile', fallback);
    default:
      return translateListFilter(type, 'TaskRelationFieldType', fallback);
  }
};

angular
  .module('cxSettings')
  .controller('AddRelationFieldDefinitionDialogCtrl', [
    '$http',
    'appUrls',
    'flySvc',
    'resourceFactorySvc',
    'enumCacheSvc',
    'translateListFilter',
    'close',
    'taskTemplateId',
    'definitions',
    '$element',

    addRelationFieldDefinitionDialogCtrl,
  ]);

function addRelationFieldDefinitionDialogCtrl(
  $http,
  appUrls,
  flySvc,
  resourceFactorySvc,
  enumCacheSvc,
  translateListFilter,
  close,
  taskTemplateId,
  definitions,
  $element,
) {
  var vm = this;

  enumCacheSvc.get('TaskRelationFieldType').then(function(data) {
    var existingTypes = definitions
      .filter(x => !!x.relationFieldType)
      .map(x => x.relationFieldType);
    vm.fieldTypes = data
      .filter(x => existingTypes.indexOf(x.key) < 0)
      .map(x => ({
        id: x.key,
        value: x.value,
        label: getTaskRelationFieldTypeLabel(x.key, translateListFilter, x.value),
      }));
    if (!vm.fieldTypes.length) {
      flySvc.warning('msgTaskTemplateHasAllAvailableRelationFields');
      $element.modal('hide');
      close(null);
    }
  });
  vm.parameterDefinition = {
    taskTemplateId: taskTemplateId,
    parameterValueType: 0, // Default to text
    systemParameterType: null,
    relationFieldType: null,
  };
  vm.showValidation = false;

  vm.relationFieldTypeChanged = function() {
    if (vm.parameterDefinition.relationFieldType > 0) {
      var type = vm.fieldTypes.find(x => x.id === vm.parameterDefinition.relationFieldType);
      if (type) {
        vm.parameterDefinition.name = type.label;
      }
    }
  };

  vm.save = function() {
    if (vm.parameterDefinition.relationFieldType <= 0) return '';
    vm.saving = true;

    $http.post(`${appUrls.tasks}/api/TaskParameters/CreateDefinition`, vm.parameterDefinition).then(
      function({ data }) {
        vm.saving = false;
        $element.modal('hide');
        close(data, 500);
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
        return '';
      },
    );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
